export const baseUrl = "/lux3/v1";
